<template>
<div class="m-report-list--wrapper">
    <div class="m-report-list">
        <ul class="m-report-list" v-html="list">
        </ul>

    </div>
    <div class="m-report-widget">
        <p class="m-report-widget__title">Выдача ипотеки</p>
        <div class="m-report-widget__block--wrp">
            <div class="m-report-widget__block">
                <p class="m-report-widget__quantity">{{ widget.quantity }} тыс. шт.</p>
                <div class="m-report-widget__wrapper" v-if="widget.quantity_diff_year">
                    <p class="m-report-widget__text">прирост за год</p>
                    <p class="m-report-widget__value" :class="isPosi(widget.quantity_diff_year)">{{
                        formatNumber(widget.quantity_diff_year) }}</p>
                </div>
                <div class="m-report-widget__wrapper" v-if="widget.quantity_diff_quarter">
                    <p class="m-report-widget__text--quarter">прирост за квартал</p>
                    <p class="m-report-widget__value" :class="isPosi(widget.quantity_diff_quarter)">{{
                        formatNumber(widget.quantity_diff_quarter) }}</p>
                </div>
            </div>
            <div class="m-report-widget__block">
                <p class="m-report-widget__quantity">{{ this.formatCurrency(widget.volume) }} млрд ₽</p>
                <div class="m-report-widget__wrapper" v-if="widget.volume_diff_year">
                    <p class="m-report-widget__text">прирост за год</p>
                    <p class="m-report-widget__value" :class="isPosi(widget.volume_diff_year)">{{
                        formatNumber(widget.volume_diff_year)
                    }}</p>
                </div>
                <div class="m-report-widget__wrapper" v-if="widget.volume_diff_quarter">
                    <p class="m-report-widget__text--quarter">прирост за квартал</p>
                    <p class="m-report-widget__value" :class="isPosi(widget.volume_diff_quarter)">{{
                        formatNumber(widget.volume_diff_quarter) }}</p>
                </div>
            </div>
        </div>

    </div>

</div>
</template>

<script>
export default {
    name: 'ListWidget',
    props: {
        list: {
            type: String,
        },
        widget: {
            type: Object
        }
    },
    methods: {
        isPosi(val) {
            if (Number(val) > 0) {
                return 'green'
            } else if (Number(val) < 0) {
                return 'red'
            } else return 'grey';
        },
        formatCurrency(value) {
            let rub = value.replace(/[^0-9,]/g, '').replace(',', '.');
            let formatRubles = new Intl.NumberFormat('ru').format(rub);
            return formatRubles;
        },
        formatNumber(val) {
            let num = Number(val);
            if (num > 0) {
                num = '+' + num;
                return num + '%';
            } else return num + '%';

        },
    }
}
</script>